module.exports = __webpack_public_path__ + "static/media/about-us.4a2ae1cb.svg";